import {Injectable} from '@angular/core'
import {HttpClient, HttpParams, HttpErrorResponse} from '@angular/common/http'

import {Observable} from 'rxjs'
import {tap} from 'rxjs/operators'

import {LoggerService} from '@app/core/services/logger.service'

import {
  ApiSearchRequest,
  ApiSearchResponse,
} from '@app/core/services/api.interface'
import {SearchResult} from './search-result.interface'

export {SearchResult}

@Injectable()
export class SearchService {
  constructor(
    private http: HttpClient,
    private logger: LoggerService,
  ) {}

  getSearch(
    request: ApiSearchRequest,
  ): Observable<ApiSearchResponse<SearchResult>> {
    const url = 'api://Search'

    // convert all object properties to strings
    let params = new HttpParams()
    if (request.search) {
      params = params.set('search', request.search)
    }
    if (request.sort) {
      params = params
        .set('sort', request.sort)
        .set('asc', !request.asc ? 'false' : 'true')
    }
    if (request.offset) {
      params = params.set('offset', request.offset.toString())
    }
    if (request.results) {
      params = params.set('results', request.results.toString())
    }

    return this.http
      .get<ApiSearchResponse<SearchResult>>(url, {params: params})
      .pipe(
        tap(
          (res) => {
            this.logger.log(res)
          },
          (err: Error) => {
            this.handleError(err)
          },
        ),
      )
  }

  private handleError(err: Error) {
    if (err instanceof HttpErrorResponse) {
      if (err.error && err.error.description) {
        throw new Error(err.error.description)
      } else {
        throw new Error('Error: ' + err.status + ' => ' + err.message)
      }
    }
  }
}
